
import { DEFAULT_PAGE_SIZE } from '@/types/pagination';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DataOptions, DataTableHeader } from 'vuetify';

export type TableHeader = string | DataTableHeader;

@Component({
    components: {},
})
export default class Table<T> extends Vue {
    @Prop({ default: '' })
    protected readonly title!: string;

    @Prop({ default: [] })
    readonly items!: T[];

    @Prop({ default: [], required: true })
    protected readonly headers!: TableHeader[];

    @Prop({ default: '' })
    protected readonly className!: string;

    @Prop({ default: 0 })
    readonly total!: number;

    @Prop({ default: DEFAULT_PAGE_SIZE })
    readonly perPage!: number;

    @Prop({ default: 1 })
    readonly page!: number;

    @Prop({ default: false })
    protected readonly loading!: boolean;

    @Prop({ default: 'Loading data...' })
    protected readonly loadingText!: string;

    @Prop({ default: false })
    readonly disableSearch!: boolean;

    @Prop({ default: '' })
    protected readonly newItemUrl?: string;

    @Prop({ type: Array, required: false, default: () => [] })
    readonly itemSlots!: any;

    @Prop({ type: Function, required: true })
    onOptionsChange!: (options: DataOptions) => void;

    @Prop({ type: Function, required: false })
    onSearchChange!: (search: string) => void;

    @Prop({ type: Function, required: false })
    onRowClick!: (row: T) => void;

    @Prop({ type: Function, required: false })
    onNewClick!: () => void;

    @Prop({ type: Function, required: false })
    onRefresh!: () => void;

    @Prop({ default: true, required: false })
    showFilters!: boolean;

    options: DataOptions = {
        page: this.page,
        itemsPerPage: this.perPage,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false,
    };

    protected debounceSearch: any | null = null;
    search = '';
    protected tableReady = true;

    mounted() {
        const { filter } = this.$route.params;
        const paramPage = this.$route.params.page ? parseInt(this.$route.params.page) : 1;
        const paramPerPage = this.$route.params.perPage ? parseInt(this.$route.params.perPage) : DEFAULT_PAGE_SIZE;
        if (filter || paramPage != 1 || paramPerPage != DEFAULT_PAGE_SIZE) this.tableReady = false;
        if (paramPerPage != DEFAULT_PAGE_SIZE)
            this.options = {
                ...this.options,
                itemsPerPage: paramPerPage,
            };
    }

    updated() {
        if (!this.tableReady) {
            const { filter } = this.$route.params;
            if (filter) this.search = filter;
            this.tableReady = true;
        }
    }

    get getClass() {
        return `${this.className || ''}`; //elevation-1
    }

    get getHeaders() {
        const defaultHeader = {
            align: 'start',
            sortable: false,
            filterable: false,
            groupable: false,
            class: 'custome-header',
        };

        return this.headers.map(header => {
            if (typeof header === 'string') {
                return {
                    ...defaultHeader,
                    text: header,
                    value: header,
                };
            }

            return {
                ...defaultHeader,
                ...header,
            };
        });
    }

    handleRowClick(row: T) {
        if (this.onRowClick) {
            this.onRowClick(row);
        }
    }

    handleRefresh() {
        if (this.onRefresh) {
            this.onRefresh();
        }
    }

    @Watch('options')
    protected optionsChanged() {
        if (this.tableReady) this.onOptionsChange(this.options);
    }

    @Watch('search')
    searchChanged() {
        if (this.onSearchChange) {
            if (this.debounceSearch) {
                clearTimeout(this.debounceSearch);
                this.debounceSearch = null;
            }

            this.debounceSearch = setTimeout(() => {
                this.onSearchChange(this.search);
            }, 500);
        }
    }
}
